'use client';

import { useContext } from 'react';
import { AuthStateContext } from './auth-provider.tsx';
import type { AuthState } from './types.ts';

/**
 * Hook to access authentication state.
 * Use this for components that only need to read auth status.
 *
 * @example
 * ```typescript
 * const { user, isAuthenticated, isLoading } = useAuthState();
 *
 * if (isLoading) return <Spinner />;
 * if (!isAuthenticated) return <LoginPrompt />;
 * return <div>Welcome, {user?.email}</div>;
 * ```
 */
export function useAuthState(): AuthState {
  const context = useContext(AuthStateContext);
  if (!context) {
    throw new Error('useAuthState must be used within AuthProvider');
  }
  return context;
}
